<template>
  <div id="tab-status">
    <component
      :is="scrollbarTag"
      class="scroll-area--customizer"
      :settings="settings"
      :key="$vs.rtl"
    >
      <ul>
        <li class="pt-2">
          <!-- 緯度 （高精度GPS） -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">緯度（高精度GPS）</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  latitudePrecise || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>
          <!-- 緯度 （GPS） -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">緯度（GPS）</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{ latitude || "---" }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>
          <!-- 経度（高精度GPS） -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">経度（高精度GPS）</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  longitudePrecise || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- 経度（GPS） -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">経度（GPS）</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  longitude || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- 対地針路（高精度GPS） -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy"
              >対地針路（高精度GPS）</span
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  courseOverGroundPrecise || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- 対地針路（GPS） -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">対地針路（GPS）</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  courseOverGround || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- 船首方位 -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">船首方位</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  vesselHeading || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- 回頭角速度 -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">回頭角速度</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  rateOfTurn || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- 対水速力 -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">対水速力</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  speedThroughWater || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- 対地速力（高精度GPS） -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy"
              >対地速力（高精度GPS）</span
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  speedOverGroundPrecise || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- 対地速力（GPS） -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">対地速力（GPS）</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  speedOverGround || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- 水深 -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">水深</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  waterDepth || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- 相対風向 -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">相対風向</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  relativeWindDirection || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- 相対風速 -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">相対風速</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  relativeWindSpeed || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- 針路指令値 -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">針路指令値</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  commandedCourseOverGround || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- 船速指令値 -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">船速指令値</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  commandedSpeedOverGround || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- オフトラック -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">オフトラック</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{ offTrack || "---" }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- ドリフト方位 -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">ドリフト方位</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  driftDirection || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>

          <!-- ドリフト速度 -->
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-light-navy">ドリフト速度</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="flex-end"
              vs-w="6"
            >
              <span class="sdf-text-18-400-white">{{
                  driftSpeed || "---"
                }}</span>
            </vs-col>
            <vs-divider class="divider-" :color="sdfColor.LightNavy"/>
          </vs-row>
        </li>
      </ul>
    </component>
  </div>
</template>

<script>
import {
  ColorMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";

// components
import VuePerfectScrollbar from "vue-perfect-scrollbar";

// Util
import {GeoUtil} from "@/utils";
import { isNumber } from "lodash";

export default {
  mixins: [ColorMixin, StoreMonitoringVesselManeuveringMixin],
  components: {VuePerfectScrollbar},
  data() {
    return {
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
        wheelSpeed: 1,
        swipeEasing: true
      }
    };
  },
  computed: {
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    latitudePrecise() {
      if (this.channelDataManeuvering) {
        if (this.channelDataManeuvering.SB02.vn === null) return "---";
        return `N${GeoUtil.toSexagesimalScale(
          this.channelDataManeuvering.SB02.vn
        )}`;
      }
    },
    latitude() {
      if (this.channelDataManeuvering) {
        if (this.channelDataManeuvering.SB07.vn === null) return "---";
        return `N${GeoUtil.toSexagesimalScale(
          this.channelDataManeuvering.SB07.vn
        )}`;
      }
    },
    longitudePrecise() {
      if (this.channelDataManeuvering) {
        if (this.channelDataManeuvering.SB03.vn === null) return "---";
        return `E${GeoUtil.toSexagesimalScale(
          this.channelDataManeuvering.SB03.vn
        )}`;
      }
    },
    longitude() {
      if (this.channelDataManeuvering) {
        if (this.channelDataManeuvering.SB08.vn === null) return "---";
        return `E${GeoUtil.toSexagesimalScale(
          this.channelDataManeuvering.SB08.vn
        )}`;
      }
    },
    courseOverGroundPrecise() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB06.vn
        )}°`;
      }
    },
    courseOverGround() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB10.vn
        )}°`
      }
    },
    vesselHeading() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB11.vn
        )}°`
      }
    },
    rateOfTurn() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB12.vn
        )}°/分`
      }
    },
    speedThroughWater() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB04.vn
        )}kt`
      }
    },
    speedOverGroundPrecise() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB05.vn
        )}kt`
      }
    },
    speedOverGround() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB09.vn
        )}kt`
      }
    },
    waterDepth() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB13.vn
        )}m`
      }
    },
    relativeWindDirection() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB14.vn
        )}°`
      }
    },
    relativeWindSpeed() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB15.vn
        )}m`
      }
    },
    commandedCourseOverGround() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB18.vn
        )}°`
      }
    },
    commandedSpeedOverGround() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB19.vn
        )}kt`
      }
    },
    offTrack() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB20.vn
        )}m`
      }
    },
    driftDirection() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB16.vn
        )}°`
      }
    },
    driftSpeed() {
      if (this.channelDataManeuvering) {
        return `${this.toFixedFirstDecimal(
          this.channelDataManeuvering.SB17.vn
        )}kt`
      }
    }
  },
  methods: {
    toFixedFirstDecimal(target) {
      if (isNumber(target)) {
        let val = Number(target).toFixed(1);
        return val === 0 ? "0.0" : String(val);
      } else {
        return "---";
      }
    }
  },
  mounted() {
  }
};
</script>

<style lang="scss"></style>
